import { Link } from "@tanstack/react-router";

import { textLink } from "@/ui";

export const CartUnavailableMessage = () => {
  return (
    <>
      {"We couldn't load your cart. Please reload the page or contact support "}
      <Link
        className={textLink}
        onClick={(event) => {
          event.stopPropagation();
        }}
        to="/messages"
      >
        here
      </Link>
      .
    </>
  );
};
